import type { OccDisplayText } from '@vista-digital/occ-ui'

export const changeOccContextDisplayText = (data: OccDisplayText): OccDisplayText => {
    return {
        ...data,
        seat: {
            ...data.seat,
            labelFormat: '${rowLabel}${seatLabel}',
            groupFormat: '${firstSeatLabel}–${lastSeatLabel}',
        },
    }
}